import { CoverageModel } from '@ctw/shared/api/fhir/models/coverage';
import type { PatientModel } from '@ctw/shared/api/fhir/models/patient';
import { fqsRequest, fqsRequestAll, MAX_OBJECTS_PER_REQUEST } from '@ctw/shared/api/fqs/client';
import { type CoverageGraphqlResponse, coverageQuery } from '@ctw/shared/api/fqs/queries/coverage';
import { usePatientQuery } from '@ctw/shared/context/patient-provider';
import type { useTelemetry } from '@ctw/shared/context/telemetry/telemetry-boundary';
import { QUERY_KEY_PATIENT_COVERAGES } from '@ctw/shared/utils/query-keys';
import type { GraphQLClient } from 'graphql-request';

export const usePatientCoverages = (enabled = true) =>
  usePatientQuery({
    queryId: QUERY_KEY_PATIENT_COVERAGES,
    enabled,
    queryFn: async ({ telemetry, graphqlClient, patient }) => {
      const { data } = await fqsRequestAll<CoverageGraphqlResponse>(
        telemetry,
        graphqlClient,
        coverageQuery,
        'CoverageConnection',
        {
          upid: patient.UPID,
          cursor: '',
          first: MAX_OBJECTS_PER_REQUEST,
          sort: {},
          filter: {},
        },
      );
      return data.CoverageConnection.edges.map((e) => new CoverageModel(e.node));
    },
  });

export async function fetchCoveragesByIdFQS(
  telemetry: ReturnType<typeof useTelemetry>,
  graphqlClient: GraphQLClient,
  patient: PatientModel,
  ids: Array<string>,
) {
  const { data } = await fqsRequest<CoverageGraphqlResponse>(
    telemetry,
    graphqlClient,
    coverageQuery,
    {
      upid: patient.UPID,
      cursor: '',
      first: MAX_OBJECTS_PER_REQUEST,
      filter: {
        ids: { anymatch: ids },
      },
      sort: {},
    },
  );
  return data.CoverageConnection.edges.map((e) => new CoverageModel(e.node));
}
